import { render, staticRenderFns } from "./designForm.vue?vue&type=template&id=5b03f115&scoped=true"
import script from "./designForm.vue?vue&type=script&lang=js"
export * from "./designForm.vue?vue&type=script&lang=js"
import style0 from "./designForm.vue?vue&type=style&index=0&id=5b03f115&prod&scoped=true&lang=css"
import style1 from "./designForm.vue?vue&type=style&index=1&id=5b03f115&prod&lang=css"
import style2 from "./designForm.vue?vue&type=style&index=2&id=5b03f115&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03f115",
  null
  
)

export default component.exports